import React, { ReactElement } from "react";
import styles from "./redirection.module.scss";
import { Button, Text } from "@kunduz/ui-atoms";
import Link from "next/link";
import { gray } from "../../theme";
import { Ranking } from "../hero";
import classNames from "classnames";

export const Redirection = (props: RedirectionProps): ReactElement => {
  return (
    <section className={classNames(styles.base, props.className)}>
      <img src={props.image} alt="" loading="lazy" />

      <div
        style={{
          display: "flex",
          alignItems: "center",
          gap: 32,
          flexDirection: "column",
        }}
      >
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            gap: 8,
          }}
        >
          <Text
            variant="displayxs"
            weight="semibold"
            style={{ color: gray[900], textAlign: "center" }}
          >
            {props.title}
          </Text>
          <div
            className={styles.description}
            dangerouslySetInnerHTML={{ __html: props.description }}
          ></div>
        </div>

        <div className={styles.titleAndButtons}>
          {props.buttonItemsTitle && (
            <p className={styles.title}>{props.buttonItemsTitle}</p>
          )}
          <div className={styles.buttonWrapper}>
            {props.buttonItems.map((item: any, i: number) => (
              <Button
                variant="secondary"
                color="gray"
                size="sm"
                key={i}
                as={Link}
                href={item.url}
                target={item.target}
                type="button"
                onClick={() =>
                  props.onButtonClicked && props.onButtonClicked(item.label)
                }
              >
                <Text variant="textsm" weight="semibold">
                  {item.label}
                </Text>
              </Button>
            ))}
          </div>
        </div>

        {props.rankingItems && props.rankingItems.length > 0 && (
          <div className={styles.rankings}>
            {props.rankingItems.map((r, i) => (
              <Ranking key={i}>
                <div
                  className={styles.ranking}
                  dangerouslySetInnerHTML={{ __html: r.text }}
                ></div>
              </Ranking>
            ))}
          </div>
        )}
      </div>
    </section>
  );
};

export type RedirectionProps = {
  title: string;
  description: string;
  image: string;
  buttonItemsTitle?: string;
  buttonItems: {
    label: string;
    url: string;
    type: string;
    target: string;
  }[];
  rankingItems: { id: number; text: string }[];
  onButtonClicked?: (label: string) => void;
  className?: string;
};
